(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/calendar-holder.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/calendar-holder.js');
"use strict";

const {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef
} = React;
const DateField = svs.components.DateField;
const {
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  regexSportinfoPathnames
} = svs.components.sportinfo.common.constants;
const {
  useFetchDate,
  useCurrentDateDraws
} = svs.components.tipsen.routeResult;
const uniqueDatesFilter = (draw, i, self) => i === self.findIndex(prev => dateFns.isSameDay(new Date(prev.date), new Date(draw.date)));
const dateIsValid = date => !Number.isNaN(new Date(date).getTime());
const CalendarHolder = () => {
  const [productBranding] = useBranding();
  const history = useHistory();
  const location = useLocation();
  const [fetchDate, currentDate, hasDateParam] = useFetchDate();
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(undefined);
  const [initialLatestFinalizedDateObject, setInitialLatestFinalizedDateObject] = useState(undefined);
  const isInitialLoad = useRef(true);
  const actualFetchDate = useMemo(() => selectedCalendarDate !== null && selectedCalendarDate !== void 0 ? selectedCalendarDate : fetchDate, [fetchDate, selectedCalendarDate]);
  const [currentDateDraws, isLoading, fetchedDates, latestFinalizedDateObj, currentDateDrawsError] = useCurrentDateDraws(actualFetchDate.year, actualFetchDate.month, currentDate, hasDateParam);
  useEffect(() => {
    if ((!dateIsValid(currentDate) || (currentDateDrawsError === null || currentDateDrawsError === void 0 ? void 0 : currentDateDrawsError.status) === 404) && isInitialLoad.current === true) {
      history.replace("/resultat");
      isInitialLoad.current = false;
    }
  }, [currentDate, currentDateDrawsError, isInitialLoad]);
  useEffect(() => {
    if (latestFinalizedDateObj && !initialLatestFinalizedDateObject) {
      setInitialLatestFinalizedDateObject(latestFinalizedDateObj);
    }
  }, [latestFinalizedDateObj]);
  const uniqueDates = useMemo(() => {
    if (fetchedDates) {
      return fetchedDates.filter(uniqueDatesFilter).map(uniqueDate => new Date(uniqueDate.date));
    }
    return undefined;
  }, [fetchedDates]);
  const formatDate = useCallback(_date => {
    if (isLoading) {
      return '';
    }

    const string = dateFns.format(new Date(_date), "EEEE d MMMM yyyy ' (v. 'w')'", {
      locale: dateFns.locales.sv
    });
    return string.charAt(0).toUpperCase() + string.slice(1);
  }, [isLoading]);
  const inputValue = dateObj => ({
    value: dateObj,
    icon: 'menu-down'
  });
  useEffect(() => {
    var _currentDateDraws$;
    if (isInitialLoad.current === true && ((_currentDateDraws$ = currentDateDraws[0]) !== null && _currentDateDraws$ !== void 0 && _currentDateDraws$.date || latestFinalizedDateObj) && location.pathname.split('/').length >= 3) {
      var _currentDateDraws$2;
      const currentDateDrawAsDate = new Date((_currentDateDraws$2 = currentDateDraws[0]) === null || _currentDateDraws$2 === void 0 ? void 0 : _currentDateDraws$2.date);
      const sportinfoTabMatch = location.pathname.match(regexSportinfoPathnames);
      const sportinfoTab = sportinfoTabMatch ? "/".concat(sportinfoTabMatch[0]) : '';
      if (dateIsValid(currentDateDrawAsDate)) {
        isInitialLoad.current = false;
        const dateParam = "".concat(currentDateDrawAsDate.getFullYear(), "-").concat((1 + currentDateDrawAsDate.getMonth()).toString().padStart(2, '0'), "-").concat(currentDateDrawAsDate.getDate().toString().padStart(2, '0'));
        history.push("/resultat/".concat(dateParam).concat(sportinfoTab).concat(location.search));
      } else if (dateIsValid(latestFinalizedDateObj)) {
        isInitialLoad.current = false;
        const dateParam = "".concat(latestFinalizedDateObj.getFullYear(), "-").concat((1 + latestFinalizedDateObj.getMonth()).toString().padStart(2, '0'), "-").concat(latestFinalizedDateObj.getDate().toString().padStart(2, '0'));
        history.push("/resultat/".concat(dateParam).concat(sportinfoTab).concat(location.search));
      }
    }
  }, [latestFinalizedDateObj, currentDateDraws]);
  const inputProps = useMemo(() => {
    if (hasDateParam) {
      return inputValue(new Date(fetchDate.year, parseInt(fetchDate.month, 10) - 1, fetchDate.day));
    }
    if (dateFns.isSameDay(initialLatestFinalizedDateObject, latestFinalizedDateObj)) {
      return inputValue(latestFinalizedDateObj);
    }
    return inputValue(initialLatestFinalizedDateObject);
  }, [fetchDate, hasDateParam, latestFinalizedDateObj, initialLatestFinalizedDateObject]);
  const onChange = useCallback(selectedDate => {
    const month = selectedDate.month + 1;
    history.replace("/resultat/".concat(selectedDate.year, "-").concat(month.toString().padStart(2, '0'), "-").concat(selectedDate.day.toString().padStart(2, '0')));
  }, [history]);
  const onViewChange = useCallback(view => {
    setSelectedCalendarDate({
      year: view.year,
      month: view.month + 1
    });
  }, []);
  const pickadateOptions = useMemo(() => ({
    isTodayOrTomorrow: false,
    klass: {
      navPrev: 'calendar-left-arrow icon-default icon-menu-left js-previous pointer',
      month: 'inline-block month-label',
      year: 'inline-block year-label',
      buttonClose: 'btn btn-100 btn-default',
      navNext: 'calendar-right-arrow icon-default icon-menu-right js-next pointer',
      opened: 'picker--opened',
      picker: 'picker date-picker-default'
    },
    openCloseInput: true,
    disable: [true].concat(uniqueDates) 
  }), [uniqueDates]);
  if (!(inputProps !== null && inputProps !== void 0 && inputProps.value)) {
    return 'Laddar...';
  }
  return React.createElement("div", {
    className: "datefield inline-block datefield--".concat(productBranding)
  }, React.createElement(DateField, {
    format: formatDate,
    inputProps: inputProps,
    onChange: onChange,
    onViewChange: onViewChange,
    pickadateOptions: pickadateOptions
  }));
};
setGlobal('svs.components.tipsen.routeResult.CalendarHolder', CalendarHolder);

 })(window);